import React from 'react'
import { Banner } from '@shopify/polaris'

class WarningBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      warning_banner: this.props.warning_banner,
    }
  }
  
  render() {
    if (this.props.warning_banner === true ) {
      return <Banner
      title="Sorry, something went wrong. Keep trying!"
      status="warning"
    >
    </Banner>
    } return null
  }
} 
 
export default WarningBanner